export default function getTaxTotal(taxes = []) {
  return taxes
    .map((tax) => tax ? tax.total : 0)
    .reduce((a, b) => a + b, 0)
}
